import React, { createContext, useContext, useEffect, useRef } from 'react';
import { io, Socket } from 'socket.io-client';
import { CLIENT_EVENT_ENUM, SERVER_EVENT_ENUM } from '@common-frontend-submodule/enums/event/event.enum';
import { IUserDetailedDTO } from '@common-frontend-submodule/interfaces/user/iuser-detailed.interface';
import { INewChatMessageDTO } from '@common-frontend-submodule/interfaces/chat-message/inew-chat-message.interface'
import { useUserStore } from '../stores/contexts/user';
import { useWorkplaceStore } from '../stores/contexts/workplace';
import config from '../boot/config';
import Log from './log';
import { Utils } from '../lib/utils';
import { IErrorDTO } from '@common-frontend-submodule/interfaces/common/ierror.interface';

const SocketContext = createContext<Socket | null>(null);

export const SocketProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const socketRef = useRef<Socket | null>(null);
  const userStore = useUserStore();
  const workplaceStore = useWorkplaceStore();
  const { CurrentUser } = userStore;

  if (!socketRef.current) {
    const { connection, options } = config.wsConfig;
    socketRef.current = io(connection, options);
  }

  useEffect(() => {
    const socket = socketRef.current!;

    const registerSockets = () => {
      if (!socket.connected) {
        socket.connect();
      }

      socket.on(SERVER_EVENT_ENUM.WHO_ARE_YOU, () => {
        const preparedUser = { ...CurrentUser } as IUserDetailedDTO;
        preparedUser.roles = preparedUser.roles?.map((role) => ({
          ...role,
          permissions: [],
        }));
        socket.emit(CLIENT_EVENT_ENUM.I_AM, preparedUser);
      });

      socket.on(SERVER_EVENT_ENUM.WORKPLACE_UPDATED, async () => {
        Log.trace(SERVER_EVENT_ENUM.WORKPLACE_UPDATED, '')
        try {
          await workplaceStore.requestAvailableWithModules();
        } catch (error: any) {
          return Utils.handleErrorResponse(error as IErrorDTO);
        }
      });

      // socket.on(SERVER_EVENT_ENUM.NEW_CHAT_MESSAGE, async (data: INewChatMessageDTO) => {
      //   Log.trace(SERVER_EVENT_ENUM.NEW_CHAT_MESSAGE, data)
      //   try {

      //   } catch (e: any) {
      //     console.error('requestAvailableWithModules error', e);
      //   }
      // });
    };

    const unregisterSockets = () => {
      socket.disconnect();
      socket.close();
    };

    registerSockets();

    return () => {
      unregisterSockets();
    };
  }, [CurrentUser, workplaceStore]);

  return <SocketContext.Provider value={socketRef.current}>{children}</SocketContext.Provider>;
};


export const useSocket = () => {
  const socket = useContext(SocketContext);
  if (!socket) {
    throw new Error('Socket is not initialized');
  }
  return socket;
};
